export default "__VITE_ASSET__Du78UIg8__"